import React from "react";

import { QuoteEmployeePriceBreakdownBody } from "EmployerApplication/Components/QuoteEmployeePriceBreakdown";
import isIntuit from "Intuit/isIntuit";
import queryString from "query-string";
import { getRecommendationMode } from "QuotePage/app/compactQuotePage/Selectors";
import { hasPlansBeforeInitialData, getMedicalPlanEnrolledId, getVisiblePlans, getPayrollLead } from "QuotePage/Selectors";
import { connect, useSelector } from "react-redux";
import { withRouter } from "react-router-dom";
import { find } from "underscore";
import { removeURLBasename } from "Utils/removeURLBasename";

import { LinkButton } from "Cobalt/Button";
import { TitleSmall } from "Cobalt/Header";
import { Modal, ModalHeader, ModalFooter, ModalBody } from "Cobalt/Modal";
import Button from "Common/Button";
import { addPlanToCart } from "Common/CartService";
import { getPlans } from "Common/PlanLoader/Selectors";

const PriceBreakdown = ({ plan, onStartApplicationClicked, history, disableButtons, medicalPlanEnrolledId, hideButton, recommendationMode, planPosition }) => {
  if (!plan) return null;
  const payrollLead = useSelector((state) => getPayrollLead(state));

  // Navigate one level up to the underlying app, since this modal is tied to a URL
  // We may navigate here from an external location, so it can't be navigate back
  const onHide = () => {
    history.push(removeURLBasename(history.location.pathname.replace(/\/price-breakdown\/[0-9]+$/, "")));
  };

  const StartApplicationButton = () => {
    if (payrollLead?.partner) {
      return (
        <LinkButton size="medium" href={`/${payrollLead.partner}/router/payroll-prospect`}>
          Get Started
        </LinkButton>
      );
    }
    return (
      <Button
        disabled={disableButtons}
        size={isIntuit() ? "medium" : undefined}
        onClick={() => {
          onStartApplicationClicked("medical", plan, {
            location: "cost_breakdown_modal",
            recommendationMode,
            position: planPosition,
          });
        }}
      >
        Get Started
      </Button>
    );
  };

  return (
    <Modal className="PriceBreakdown" show onHide={onHide}>
      <ModalHeader closeButton className={isIntuit() ? "PriceBreakdown__headerContainer" : undefined}>
        <div className="PriceBreakdown__header">
          <TitleSmall m={0}>Price Breakdown</TitleSmall>
        </div>
      </ModalHeader>
      <ModalBody>
        <QuoteEmployeePriceBreakdownBody plan={plan} />
      </ModalBody>
      <ModalFooter>{medicalPlanEnrolledId != plan.id && !hideButton && <StartApplicationButton />}</ModalFooter>
    </Modal>
  );
};

const mapStateToProps = (state, ownProps) => {
  const plan = find(getPlans(state), (plan) => plan.id == ownProps.match.params.id);
  const position = getVisiblePlans(state).findIndex((p) => p.id === plan.id) + 1;
  // hide start application button based on query parameter disableButton ('bhacl' = 'button hidden at current location')
  const hiddenViaQuery = queryString.parse(ownProps.location.search).bhacl === "true";
  return {
    plan,
    planPosition: position,
    disableButtons: hasPlansBeforeInitialData(state),
    medicalPlanEnrolledId: getMedicalPlanEnrolledId(state),
    hideButton: hiddenViaQuery,
    recommendationMode: getRecommendationMode(state),
  };
};

const mapDispatchToProps = (dispatch) => ({
  onStartApplicationClicked: (planType, plan, tracking = {}) => {
    dispatch(
      addPlanToCart({
        planType,
        plan,
        tracking,
        shouldClearDentalVision: false,
        continueToCart: true,
      }),
    );
  },
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PriceBreakdown));
